import type { UserAction } from "@brookbush/types";

import { setCookie } from "cookies-next";

const useTrackCTA = () => {
	const trackCTA = (userAction: UserAction, description: string) => {
		setCookie(`${userAction}:cta-click`, description);
	};

	return trackCTA;
};

export default useTrackCTA;
